export enum IncomeStockMovementType {
  PURCHASE = 'PURCHASE',
  TRANSFER = 'TRANSFER',
  PRODUCTION = 'PRODUCTION',
  INVENTORY_SURPLUS = 'INVENTORY_SURPLUS'
}
